import { IPreferenceOptions } from "v3/data/store/preferenceOptions/types";

export const preferenceOptionsInitialState:IPreferenceOptions = {
  preferenceOptions: [],
}